import axios from "axios";
import { encryptStorage } from "../../../../constants/EncryptStorage";
import getUrl from "../../../../constants/urlConst";


export function CommonApi() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: getUrl(),
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

  return {
    addUser: async (model) => {
      try {
        const response = await authAxios.post(getUrl() + "users", model);
        return response.data;
      } catch (error) {
        console.error("Error adding record:", error);
        throw error;
      }
    },

    deleteUser: async (userId) => {
      try {
        const response = await authAxios.delete(getUrl() + `user/${userId}`);
        return response.data;
      } catch (error) {
        console.error("Error deleting user:", error);
        throw error;
      }
    },

    updateUser: async (userId, model) => {
      try {
        const response = await authAxios.put(getUrl() + `user/${userId}`, model);
        return response.data;
      } catch (error) {
        console.error("Error updating user:", error);
        throw error;
      }
    },

    getUserById: async (userId) => {
      try {
        const response = await authAxios.get(getUrl() + `user/${userId}`);
        return response.data;
      } catch (error) {
        console.error("Error getting user:", error);
        throw error;
      }
    },
    
    createUserAccess: async (model) => {
      try {
        const response = await authAxios.post(getUrl() + "createAccess", model);
        return response.data;
      } catch (error) {
        console.error("Error adding record:", error);
        throw error;
      }
    },
    
    removeUserAccess: async (model) => {
      try {
        const response = await authAxios.post(getUrl() + "removeAccess", model);
        return response.data;
      } catch (error) {
        console.error("Error adding record:", error);
        throw error;
      }
    },
  };
}
